import React, { Component } from "react";
import { getInstitution, getMembers, downloadSO,downloadEmployerSO, downloadMembers, downloadInvoice } from "../../actions/institutionActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

class ViewInstitution extends Component {
  constructor(props) {
    super();
    this.state = {
      id: "",
      institutionName: "",
      address: "",
      phone: "",
      email: "",
      sector: "",
      tuPercentage: "",
      startDate: "",
      endDate: "",
      institutionId: "",
      errors: {},
    };
    this.cancel = this.cancel.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.downloadSchedule = this.downloadSchedule.bind(this);
    this.downloadEmployerSchedule = this.downloadEmployerSchedule.bind(this);
    this.downloadMembers = this.downloadMembers.bind(this);
    this.downloadInvoice = this.downloadInvoice.bind(this);
  }

  exportCSV() {
    this.dt.exportCSV();
  }

  componentDidMount() {
    const { institutionId } = this.props.match.params;
    this.setState({ institutionId: institutionId })
    this.props.getInstitution(institutionId, this.props.history);
    this.props.getMembers(institutionId, this.props.history);
  }

  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    const {
      id,
      institutionName,
      address,
      phone,
      email,
      sector,
      tuPercentage,
    } = nextProps.institution;

    this.setState({
      id,
      institutionName,
      address,
      phone,
      email,
      sector,
      tuPercentage,
    });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  cancel() {
    this.props.history.push("/institution-list");
  }

  downloadSchedule() {
    downloadSO(this.state.id, this.state.startDate, this.state.endDate);
  }

  downloadEmployerSchedule() {
    downloadEmployerSO(this.state.id, this.state.startDate, this.state.endDate);
  }

  downloadInvoice() {
    downloadInvoice(this.state.id);
  }
  downloadMembers() {
    downloadMembers(this.state.id);
  }

  render() {
    const { errors } = this.state;
    const header = (
      <div style={{ textAlign: "left" }}>
        <Button
          type="button"
          icon="pi pi-external-link"
          label="Download CSV"
          onClick={this.exportCSV}
        ></Button>
        {" "}
        <Button
          type="button"
          icon="pi pi-external-link"
          label="Download PDF"
          onClick={this.downloadMembers}
        ></Button>
        {" "}
        <Button
          type="button"
          icon="pi pi-external-link"
          label="Download Invoice"
          onClick={this.downloadInvoice}
        ></Button>
      </div>
    );

    return (
      <div className="container mt-4">

        <div className="card m-auto  shadow-lg rounded p-3">
          <h5 className="display-4 text-center">
            {this.state.institutionName}
          </h5>
          <p className="lead text-center">Institution Details</p>
          <hr />
          {errors.message && (
            <div className="alert alert-danger text-center" role="alert">
              {errors.message}
            </div>
          )}
          <div className="row">
            <div className="form-group col">
              <label>Institution Address: </label>{" "}
              <label>{this.state.address}</label>
            </div>

            <div className="form-group col">
              <label>Institution Phone: </label>{" "}
              <label>{this.state.phone}</label>
            </div>
          </div>
          <div className="row">
            <div className="form-group col ">
              <label>Email: </label> <label>{this.state.email}</label>
            </div>

            <div className="form-group col">
              <label>Sector: </label>{" "}
              <label>{(this.state.sector && this.state.sector.sectorName) || ""}</label>
            </div>
          </div>
          <div className="row">
            <div className="form-group col">
              <label>TU Percentage: </label>{" "}
              <label>{this.state.tuPercentage}</label>
            </div>
          </div>
          <div className="form-group col">
            <button className="btn bg-secondary" onClick={this.cancel}>
              Cancel
            </button>
          </div>

          <hr />
          <p className="lead text-center">View Stop Order Schedule</p>
          <div className="row">
            <div className="col-sm-4">
              <label>Start Date</label>
              <input
                type="date"
                required
                className="form-control"
                name="startDate"
                onChange={this.onChange}
                value={this.state.startDate || ""}
              />
            </div>
            <div className="col-sm-4">
              <label>End Date</label>
              <input
                type="date"
                required
                className="form-control "
                name="endDate"
                onChange={this.onChange}
                value={this.state.endDate || ""}
              />
            </div>
            <div className="col-sm-4 d-flex justify-content-bottom">

              <Button

                type="button"
                icon="pi pi-external-link"
                label="Download Schedule"
                onClick={this.downloadSchedule}
              ></Button>

              <Button

                type="button"
                icon="pi pi-external-link"
                label="Download Employer Schedule"
                onClick={this.downloadEmployerSchedule}
              ></Button>
            </div>
          </div>


          <hr />
          <p className="lead text-center">Membership list</p>
          <div className="card">
            <DataTable
              value={this.props.memberinstitution}
              header={header}
              ref={(el) => {
                this.dt = el;
              }}
            >
              <Column field="id" header="Id"></Column>
              <Column field="amount" header="Subscription"></Column>
              <Column field="surname" header="Surname"></Column>
              <Column field="firstname" header="Firstname"></Column>
            </DataTable>
          </div>
        </div>
      </div>

    );
  }
}

ViewInstitution.propTypes = {
  getMembers: PropTypes.func.isRequired,
  getInstitution: PropTypes.func.isRequired,
  institution: PropTypes.object.isRequired,

  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  institution: state.institution.institution,
  memberinstitution: state.institution.memberinstitution,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getMembers,
  getInstitution,
})(ViewInstitution);
